"use client"

import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import DatePicker, { registerLocale } from "react-datepicker"
import ContentHeader from "../../components/ContentHeader"
import Loader from "../../components/Loader"
import axios from "axios"
import Swal from "sweetalert2"
import $ from "jquery"
import "datatables.net-bs4"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
import "select2"
import "select2/dist/css/select2.min.css"
import { Tooltip, Modal } from "bootstrap"
import es from "date-fns/locale/es"
import "react-datepicker/dist/react-datepicker.css"
import SeatSelected from "../../assets/images/seat_selected.svg"
import SeatTaken from "../../assets/images/seat_taken.svg"
import SeatAvailable from "../../assets/images/seat_available.svg"
import Volante from "../../assets/images/volante.png"
registerLocale("es", es)

const Tickets = () => {
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState([])
  const [schedule_id, setScheduleId] = useState(0)
  const [branchs, setBranchs] = useState([])
  const [branch_id, setBranchId] = useState(0)
  const [origins, setOrigins] = useState([])
  const [origin_id, setOriginId] = useState(0)
  const [origin, setOrigin] = useState("")
  const [destinations, setDestinations] = useState([])
  const [destination_id, setDestinationId] = useState(0)
  const [destination, setDestination] = useState("")
  const [date, setDate] = useState(new Date())
  const [date_max, setDateMax] = useState(new Date())
  const [dateSelect, setDateSelect] = useState("")
  const [timeSelect, setTimeSelect] = useState("")
  const [available, setAvailable] = useState(0)
  const [occupiedSeats, setOccupiedSeats] = useState([])
  const [selectedSeats, setSelectedSeats] = useState([])
  const [forms, setForms] = useState({})
  const [total, setTotal] = useState(0)
  const [petTotal, setPetTotal] = useState(0)
  const [luggageTotal, setLuggageTotal] = useState(0)
  const [transactionType, setTransactionType] = useState(1)
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT
  const [seatData, setSeatData] = useState([])

  const [selectedUserId, setSelectedUserId] = useState(0);
  const [users, setUsers] = useState([]);

  // Estados para guardar los valores ORIGINALES de la corrida seleccionada
  const [selectedBranchId, setSelectedBranchId] = useState(0)
  const [selectedOriginId, setSelectedOriginId] = useState(0)
  const [selectedDestinationId, setSelectedDestinationId] = useState(0)

  const [ticketType, setTicketType] = useState("printed"); // "whatsapp" o "printed"
  const [isRoundTrip, setIsRoundTrip] = useState(false)
  const [returnDate, setReturnDate] = useState(new Date())
  const [tripStage, setTripStage] = useState("outbound")
  const [outboundPurchaseOrder, setOutboundPurchaseOrder] = useState("")
  const [outboundTicketId, setOutboundTicketId] = useState("")
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [confirmationSummary, setConfirmationSummary] = useState([])
  const [outboundPassengerTemplates, setOutboundPassengerTemplates] = useState([])

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("dataUser"));
    if (user && user.user_id === 13) {
      fetchUsers();
    }
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(ENDPOINT + "get-all-users"); // Ajusta el endpoint según tu API
      setUsers(response.data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    getAllBranchs()
    getAllOrigins()
    const date = new Date()
    date.setDate(date.getDate() + 7)
    setDateMax(date)
    setTimeout(() => {
      $(".select2").select2({ width: "100%", placeholder: "Seleccione" })
    }, 100)
    // Initialize tooltips
    const initTooltips = () => {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.forEach(tooltipTriggerEl => {
        new Tooltip(tooltipTriggerEl, {
          trigger: 'hover',
          html: true
        })
      })
    }

    setTimeout(initTooltips, 100)
    var table = $(".main").DataTable()
    table.destroy()
    setTimeout(() => {
      $(".main").DataTable({
        searching: true,
        destroy: true,
        retrieve: true,
        pageLength: 50,
        responsive: false,
        autoWidth: false,
        paging: true,
        ordering: true,
        sortable: true,
        processing: false,
        serverSide: false,
        bInfo: true,
        language: {
          decimal: "",
          emptyTable: "",
          info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered: "(filtrado de un total de _MAX_ registros)",
          infoPostFix: "",
          thousands: ",",
          lengthMenu: "Mostrar _MENU_ registros",
          loadingRecords: "Cargando...",
          processing: "Procesando...",
          search: "Buscar:",
          paginate: {
            first: "<i class='fa-solid fa-circle-chevron-left'></i>",
            last: "<i class='fa-solid fa-circle-chevron-right'></i>",
            next: "<i class='fas fa-arrow-circle-right'></i>",
            previous: "<i class='fas fa-arrow-circle-left'></i>",
          },
          zeroRecords: "No hay registros",
          searchPlaceholder: "Buscar...",
        },
      })
      setLoading(false)
    }, 100)
  }, [])

  useEffect(() => {
    calculateTotal()
    let newPetTotal = 0 // Changed from const to let
    let newLuggageTotal = 0 // Changed from const to let
    let newPriceTotal = 0 // Changed from const to let

    Object.values(forms).forEach((seatForm) => {
      newPetTotal += Number.parseFloat(seatForm.petAmount || 0)
      newLuggageTotal += Number.parseFloat(seatForm.extraLuggageAmount || 0)
      newPriceTotal += Number.parseFloat(seatForm.price || 0)
    })
    setPetTotal(newPetTotal)
    setLuggageTotal(newLuggageTotal)
    setTotal(newPetTotal + newLuggageTotal + newPriceTotal)
  }, [forms])

  const status_trip = [
    { label: "Comprar", value: 1 },
    { label: "Reservar", value: 2 },
  ]

  const legendItems = [
  { status: "Disponible", colorClass: "bg-success", icon: SeatAvailable },
  { status: "Reservado", colorClass: "bg-warning", icon: SeatTaken },
  { status: "Seleccionado", colorClass: "bg-primary", icon: SeatSelected },
  { status: "Restricción", colorClass: "bg-brown", icon: SeatAvailable, 
    style: { filter: "sepia(0.3) saturate(1.5)", border: "2px solid #8B4513" } }, // Nuevo
]

  const busLayout11 = {
    row1: [0, 0, 0, 0, 1],
    row2: [2, 3, 0, 0, 0],
    row3: [4, 5, 0, 0, 0],
    row4: [7, 8, 0, 0, 6],
    row5: [10, 11, 0, 0, 9],
  }

  const busLayout12 = {
    row1: [0, 0, 0, 0, 1],
    row2: [2, 3, 0, 0, 0],
    row3: [4, 5, 0, 0, 6],
    row4: [7, 8, 0, 0, 9],
    row5: [10, 11, 0, 12, 0],
  }

  const busLayout18 = {
    row1: [0, 0, 0, 18, 1],
    row2: [2, 3, 0, 17, 0],
    row3: [4, 5, 0, 0, 6],
    row4: [7, 8, 0, 0, 9],
    row5: [15, 16, 0, 0, 14],
    row6: [10, 11, 0, 12, 13],
  }

  const busLayout20 = {
    row1: [0, 0, 0, 20, 1],
    row2: [2, 3, 0, 0, 0],
    row3: [4, 5, 0, 0, 6],
    row4: [7, 8, 0, 0, 9],
    row5: [15, 16, 0, 0, 17],
    row6: [18, 19, 0, 0, 14],
    row7: [10, 11, 0, 12, 13],
  }

  $("#branch_id").on("change", (e) => {
    setBranchId(e.target.value)
  })

  $("#origin_id").on("change", (e) => {
    setOriginId(e.target.value)
    getAllDestinations(e.target.value)
  })

  $("#destination_id").on("change", (e) => {
    setDestinationId(e.target.value)
  })

  const handleSearch = async (e) => {
    e.preventDefault()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const userRole = user.rol_id 
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const dateFormat = year + "-" + month + "-" + day
    if (isRoundTrip && returnDate <= date) {
      Swal.fire({
        icon: "error",
        title: '<div className="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div className="text-custom-alert">La fecha de vuelta debe ser posterior a la fecha de ida.</div>',
      })
      return
    }
    const branchId = $("#branch_id").val()
    const originId = $("#origin_id").val()
    const destinationId = $("#destination_id").val()
    const form = new FormData()
    form.append("branch_id", branchId)
    form.append("origin_id", originId)
    form.append("destination_id", destinationId)
    form.append("date", dateFormat)
    form.append("type", "admin")
    form.append("user_role", userRole)
    setLoading(true)
    await axios
      .post(ENDPOINT + "search-trip", form)
      .then((response) => {
        setSearch(response.data.data)
        var table = $(".main").DataTable()
        table.destroy()
        setTimeout(() => {
          $(".main").DataTable({
            searching: true,
            destroy: true,
            retrieve: true,
            pageLength: 50,
            responsive: false,
            autoWidth: false,
            paging: true,
            ordering: true,
            sortable: true,
            processing: false,
            serverSide: false,
            bInfo: true,
            language: {
              decimal: "",
              emptyTable: "",
              info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
              infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              infoFiltered: "(filtrado de un total de _MAX_ registros)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ registros",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              paginate: {
                first: "<i class='fa-solid fa-circle-chevron-left'></i>",
                last: "<i class='fa-solid fa-circle-chevron-right'></i>",
                next: "<i class='fas fa-arrow-circle-right'></i>",
                previous: "<i class='fas fa-arrow-circle-left'></i>",
              },
              zeroRecords: "No hay registros",
              searchPlaceholder: "Buscar...",
            },
          })
          setLoading(false)
        }, 100)
      })
      .catch((error) => {
        setLoading(false)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + (error.response?.data?.msg || "Error desconocido") + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }

  // quick search: solo realiza la búsqueda y rellena la tabla (comportamiento original)
  const handleQuickSearch = async (branchId, originId, destinationId) => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const userRole = user.rol_id

    const today = new Date()
    const year = today.getFullYear()
    const month = (today.getMonth() + 1).toString().padStart(2, "0")
    const day = today.getDate().toString().padStart(2, "0")
    const dateFormat = year + "-" + month + "-" + day

    // Set branch and origin first
    setBranchId(branchId)
    setOriginId(originId)
    
    // Update branch and origin selects
    $(`#branch_id`).val(branchId).trigger("change")
    $(`#origin_id`).val(originId).trigger("change")
    
    // Wait for destinations to load
    await getAllDestinations(originId)
    
    // Then set destination
    setDestinationId(destinationId)
    $(`#destination_id`).val(destinationId).trigger("change")

    const form = new FormData()
    form.append("branch_id", branchId)
    form.append("origin_id", originId)
    form.append("destination_id", destinationId)
    form.append("date", dateFormat)
    form.append("type", "admin")
    form.append("user_role", userRole)

    setLoading(true)
    await axios
      .post(ENDPOINT + "search-trip", form)
      .then((response) => {
        setSearch(response.data.data)
        var table = $(".main").DataTable()
        table.destroy()
        setTimeout(() => {
          $(".main").DataTable({
            searching: true,
            destroy: true,
            retrieve: true,
            pageLength: 50,
            responsive: false,
            autoWidth: false,
            paging: true,
            ordering: true,
            sortable: true,
            processing: false,
            serverSide: false,
            bInfo: true,
            language: {
              decimal: "",
              emptyTable: "",
              info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
              infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              infoFiltered: "(filtrado de un total de _MAX_ registros)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ registros",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              paginate: {
                first: "<i class='fa-solid fa-circle-chevron-left'></i>",
                last: "<i class='fa-solid fa-circle-chevron-right'></i>",
                next: "<i class='fas fa-arrow-circle-right'></i>",
                previous: "<i class='fas fa-arrow-circle-left'></i>",
              },
              zeroRecords: "No hay registros",
              searchPlaceholder: "Buscar...",
            },
          })
          setLoading(false)
        }, 100)
      })
      .catch((error) => {
        setLoading(false)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }

  // quick nearest: usa search-trip para obtener corridas y selecciona la corrida más próxima, luego abre modal
  const handleQuickNearest = async (branchId, originId, destinationId) => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const userRole = user.rol_id 
    
    // Obtener fecha actual en formato YYYY-MM-DD
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const dateFormat = year + "-" + month + "-" + day;
    
    // Establecer los valores en los selectores
    setBranchId(branchId);
    setOriginId(originId);
    setDestinationId(destinationId);
    
    // Actualizar los select2
    setTimeout(() => {
      $(`#branch_id`).val(branchId).trigger('change');
      $(`#origin_id`).val(originId).trigger('change');
      $(`#destination_id`).val(destinationId).trigger('change');
    }, 100);
    
    // Preparar y enviar el formulario
    const form = new FormData();
    form.append("branch_id", branchId);
    form.append("origin_id", originId);
    form.append("destination_id", destinationId);
    form.append("date", dateFormat);
    form.append("type", "admin");
    form.append("user_role", userRole);
    
    setLoading(true);
    await axios
      .post(ENDPOINT + "search-trip", form)
      .then((response) => {
        const schedules = response.data.data || [];
        setSearch(schedules);

        // Si no hay corridas, mostrar alerta y terminar
        if (!schedules.length) {
          setLoading(false);
          Swal.fire({
            icon: "info",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: true,
            html: '<div class="text-custom-alert">No se encontraron corridas para la fecha seleccionada.</div>',
          });
          return;
        }

        // Función auxiliar: convertir HH:MM[:SS] a minutos desde medianoche
        const timeToMinutes = (t) => {
          if (!t) return 0;
          const parts = t.split(":");
          const h = parseInt(parts[0], 10) || 0;
          const m = parseInt(parts[1], 10) || 0;
          return h * 60 + m;
        };

        // Ordenar corridas por horario ascendente
        schedules.sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time));

        const now = new Date();
        const nowMinutes = now.getHours() * 60 + now.getMinutes();
        const thresholdMinutes = 10; // ventana para tomar la corrida anterior si está dentro de este margen

        // Buscar la última corrida con horario <= ahora
        const past = schedules.filter((s) => timeToMinutes(s.time) <= nowMinutes);
        let chosen = null;
        if (past.length > 0) {
          const last = past[past.length - 1];
          if (nowMinutes - timeToMinutes(last.time) <= thresholdMinutes) {
            chosen = last;
          }
        }

        // Si no tomamos la corrida anterior, elegir la siguiente disponible
        if (!chosen) {
          chosen = schedules.find((s) => timeToMinutes(s.time) > nowMinutes) || schedules[0];
        }

        // Establecer selects visibles
        setBranchId(branchId);
        setOriginId(originId);
        setDestinationId(destinationId);
        setTimeout(() => {
          $(`#branch_id`).val(branchId).trigger("change");
          $(`#origin_id`).val(originId).trigger("change");
          $(`#destination_id`).val(chosen.destination_id || destinationId).trigger("change");
        }, 100);

        // Elegir la corrida seleccionada y abrir modal
        handleChooseTrip(
          chosen.schedule_id, 
          chosen.origin, 
          chosen.destination, 
          chosen.date, 
          chosen.time, 
          chosen.available,
          chosen.branch_id || branchId,
          chosen.origin_id || originId,
          chosen.destination_id || destinationId
        );
        try {
          const modalEl = document.getElementById("modal-default");
          if (modalEl) {
            const bsModal = new Modal(modalEl);
            bsModal.show();
          }
        } catch (e) {
          console.log("Error mostrando modal:", e);
        }

        var table = $(".main").DataTable();
        table.destroy();
        setTimeout(() => {
          $(".main").DataTable({
            searching: true,
            destroy: true,
            retrieve: true,
            pageLength: 50,
            responsive: false,
            autoWidth: false,
            paging: true,
            ordering: true,
            sortable: true,
            processing: false,
            serverSide: false,
            bInfo: true,
            language: {
              decimal: "",
              emptyTable: "",
              info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
              infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              infoFiltered: "(filtrado de un total de _MAX_ registros)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ registros",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              paginate: {
                first: "<i class='fa-solid fa-circle-chevron-left'></i>",
                last: "<i class='fa-solid fa-circle-chevron-right'></i>",
                next: "<i class='fas fa-arrow-circle-right'></i>",
                previous: "<i class='fas fa-arrow-circle-left'></i>",
              },
              zeroRecords: "No hay registros",
              searchPlaceholder: "Buscar...",
            },
          });
          setLoading(false);
        }, 100);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      });
  };

  const handleWhatsAppSend = async (purchase_order) => {
    setLoading(true);
    const form = new FormData();
    const user = JSON.parse(localStorage.getItem("dataUser"));
    const user_id = user.user_id;
    form.append("purchase_order", purchase_order);
    form.append("user_id", user_id);
    
    try {
      const response = await axios.post(ENDPOINT + "print-image-ticket-Purchase", form);
      setLoading(false);
      resetAll();
      // Limpiar pantalla espejo (mirror) al generar el boleto
      try {
        updateMirrorDisplay([], [], 0, { base: "", origin: "", destination: "", date: "", time: "" })
      } catch (err) {
        console.warn("No se pudo actualizar mirror después de generar boleto:", err)
      }
    
      // Mostrar notificación en Tickets también
      try {
        Swal.fire({
          icon: "success",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: false,
          timer: 3000,
          html: '<div class="text-custom-alert">Boleto enviado por WhatsApp correctamente</div>',
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      } catch (err) {
        console.log("Boleto enviado por WhatsApp correctamente")
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Error al enviar por WhatsApp: ' + error.response?.data?.msg || "Error desconocido" + "</div>",
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
    }
  };

  const getDefaultPassengerForm = () => ({
    name: "",
    last_name: "",
    email: "",
    phone: "",
    price: 0,
    seat: 0,
    pickupLocation: "",
    notes: "",
    cardPayment: 2,
    cardPaymentTransfer: 2,
    transferNumber: 0,
    extraLuggage: 2,
    extraLuggageAmount: 0,
    pet: 2,
    petAmount: 0,
    courtesy: 2,
  })

  const formatDisplayDate = (value) => {
    if (!value) return "—"

    const parsedDate = new Date(value)
    const day = parsedDate.getDate().toString().padStart(2, "0")
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0")
    const year = parsedDate.getFullYear()

    return `${day}/${month}/${year}`
  }

  const buildConfirmationSummary = () => {
    const currentItems = selectedSeats.map((seatNumber) => {
      const form = forms[seatNumber] || {}
      return {
        seat: seatNumber,
        passenger: `${form.name || ""} ${form.last_name || ""}`.trim() || "Sin nombre",
        price: Number(form.price || 0),
      }
    })

    const totalByLeg = currentItems.reduce((sum, item) => sum + Number(item.price || 0), 0)
    const routeTime = timeSelect || "—"

    if (tripStage === "return" && outboundPurchaseOrder) {
      const outboundItems = outboundPassengerTemplates.map((passenger, index) => ({
        seat: passenger?.seat || index + 1,
        passenger: `${passenger?.name || ""} ${passenger?.last_name || ""}`.trim() || "Sin nombre",
        price: Number(passenger?.price || 0),
      }))
      return [
        {
          label: "Ida",
          date: formatDisplayDate(date),
          time: routeTime,
          items: outboundItems,
          total: outboundItems.reduce((sum, item) => sum + Number(item.price || 0), 0),
        },
        {
          label: "Vuelta",
          date: formatDisplayDate(returnDate),
          time: routeTime,
          items: currentItems,
          total: totalByLeg,
        },
      ]
    }

    return [{
      label: "Compra",
      date: formatDisplayDate(date),
      time: routeTime,
      items: currentItems,
      total: totalByLeg,
    }]
  }

  const executeTicketSave = async () => {
    const user = JSON.parse(localStorage.getItem("dataUser"));
    const user_id = user && user.user_id === 13
      ? (selectedUserId > 0 ? selectedUserId : user.user_id)
      : user.user_id;
    const form = new FormData();
    const dataForm = JSON.stringify(forms);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const dateFormat = dateSelect || year + "-" + month + "-" + day;

    if (!selectedSeats.length) {
      Swal.fire({
        icon: "warning",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Debe seleccionar al menos un asiento para continuar.</div>',
      })
      return
    }

    form.append("branch_id", selectedBranchId);
    form.append("origin_id", selectedOriginId);
    form.append("destination_id", selectedDestinationId);
    form.append("schedule_id", schedule_id);
    form.append("user_id", user_id);
    form.append("date", dateFormat);
    form.append("time", timeSelect);
    form.append("data", dataForm);
    form.append("status", transactionType);
    form.append("type", 1);
    if (tripStage === "return" && outboundPurchaseOrder) {
      form.append("purchase_order", outboundPurchaseOrder);
    }
    setLoading(true);

    await axios
      .post(ENDPOINT + "save-ticket", form)
      .then((response) => {
        setLoading(false);
        setShowConfirmation(false);
        setConfirmationSummary([]);

        if (isRoundTrip && tripStage === "outbound") {
          const returnYear = returnDate.getFullYear();
          const returnMonth = (returnDate.getMonth() + 1).toString().padStart(2, "0");
          const returnDay = returnDate.getDate().toString().padStart(2, "0");
          const returnDateFormat = `${returnYear}-${returnMonth}-${returnDay}`;
          const reverseOriginId = selectedDestinationId;
          const reverseDestinationId = selectedOriginId;
          const returnBranchId = Number(selectedBranchId) === 1
            ? 2
            : Number(selectedBranchId) === 2
              ? 1
              : selectedBranchId;
          const returnForm = new FormData();

          returnForm.append("branch_id", returnBranchId);
          returnForm.append("origin_id", reverseOriginId);
          returnForm.append("destination_id", reverseDestinationId);
          returnForm.append("date", returnDateFormat);
          returnForm.append("type", "admin");
          returnForm.append("user_role", JSON.parse(localStorage.getItem("dataUser"))?.rol_id || 0);

          const preservedTemplates = Object.values(forms).map((passengerForm) => ({
            ...getDefaultPassengerForm(),
            ...passengerForm,
            name: passengerForm?.name || "",
            last_name: passengerForm?.last_name || "",
            email: passengerForm?.email || "",
            phone: passengerForm?.phone || "",
            price: Number(passengerForm?.price || 0),
            seat: passengerForm?.seat || 0,
          }))
          const savedTicketData = response?.data?.data || {}
          const savedTicketId = savedTicketData.ticket_id || savedTicketData.id || savedTicketData
          const savedPurchaseOrder = savedTicketData.purchase_order || savedTicketData

          setOutboundPassengerTemplates(preservedTemplates)
          setOutboundPurchaseOrder(savedPurchaseOrder)
          setOutboundTicketId(savedTicketId)
          setTripStage("return");
          setSelectedSeats([]);
          setForms({});
          setTotal(0);
          setPetTotal(0);
          setLuggageTotal(0);
          setSeatData([]);
          setOccupiedSeats([]);
          setLoading(true);
          document.querySelector("#modal-default .btn-close")?.click();

          axios.post(ENDPOINT + "search-trip", returnForm)
            .then((returnResponse) => {
              setSearch(returnResponse.data.data || []);
              setLoading(false);
              Swal.fire({
                icon: "success",
                title: '<div className="title-custom-alert">' + TITLEALERT + "</div>",
                showConfirmButton: true,
                html: '<div className="text-custom-alert">Ida guardada. Seleccione la corrida para la vuelta.</div>',
              });
            })
            .catch((error) => {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: '<div className="title-custom-alert">' + TITLEALERT + "</div>",
                showConfirmButton: true,
                html: '<div className="text-custom-alert">' + (error.response?.data?.msg || "No se encontraron corridas de vuelta") + "</div>",
              });
            });
          return;
        }

        resetAll();
        try {
          updateMirrorDisplay([], [], 0, { base: "", origin: "", destination: "", date: "", time: "" })
        } catch (err) {
          console.warn("No se pudo actualizar mirror después de generar boleto:", err)
        }
        $("#closemodal").trigger("click");

        try {
          const purchasePayload = {
            message: "Gracias por tu compra. ¡Que tengas buen viaje!",
            serverMsg: response.data?.msg || "Compra realizada",
            timestamp: new Date().toISOString(),
            show: true,
          }
          localStorage.setItem("mirrorPurchase", JSON.stringify(purchasePayload))
          window.dispatchEvent(new StorageEvent('storage', {
            key: 'mirrorPurchase',
            newValue: JSON.stringify(purchasePayload)
          }));
          window.dispatchEvent(new Event('forceMirrorUpdate'));

          try {
            Swal.fire({
              icon: "success",
              title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
              showConfirmButton: false,
              timer: 3000,
              html: '<div class="text-custom-alert">' + (response.data?.msg || "Compra guardada") + "</div>",
              showClass: { popup: "animate__animated animate__fadeInDown" },
              hideClass: { popup: "animate__animated animate__fadeOutUp" },
            })
          } catch (err) {
            console.warn("No se pudo mostrar Swal en Tickets (success):", err)
          }
        } catch (err) {
          console.warn("No se pudo notificar mirrorPurchase:", err)
        }

        if (ticketType === "whatsapp") {
          handleWhatsAppSend(response.data.data);
        } else {
          handlePrint(response.data.data);
        }

        $("#search").trigger("click");
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + (error.response?.data?.msg || "Ocurrió un error al guardar el boleto") + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedSeats.length) {
      Swal.fire({
        icon: "warning",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Selecciona al menos un asiento antes de confirmar la compra.</div>',
      })
      return;
    }

    if (isRoundTrip && tripStage === "outbound") {
      await executeTicketSave();
      return;
    }

    if (isRoundTrip && tripStage === "return") {
      const invalidSeats = selectedSeats.filter((seatNumber) => {
        const price = Number(forms[seatNumber]?.price || 0)
        return !Number.isFinite(price) || price <= 0
      })

      if (invalidSeats.length > 0) {
        Swal.fire({
          icon: "warning",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">Antes de confirmar la vuelta, establece el precio para el asiento(s): ' + invalidSeats.join(", ") + '.</div>',
        })
        return;
      }

      if (showConfirmation) {
        await executeTicketSave();
        return;
      }

      const summary = buildConfirmationSummary();
      setConfirmationSummary(summary);
      setShowConfirmation(true);
      return;
    }

    await executeTicketSave();
  };

  const getAllBranchs = async () => {
    setLoading(true)
    const response = await axios.get(ENDPOINT + "get-all-branchs-ticket")
    const branchsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.branch_id,
    }))
    setBranchs(branchsArray)
    setLoading(false)
  }

  const getAllOrigins = async () => {
    const response = await axios.get(ENDPOINT + "get-all-origins-ticket")
    const originsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.destination_id,
    }))
    setOrigins(originsArray)
  }

  const getAllDestinations = async (origin_id) => {
    setDestinations([])
    setLoading(true)
    const response = await axios.get(ENDPOINT + "get-all-destinations-ticket/" + origin_id)
    const destinationsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.destination_id,
    }))
    setDestinations(destinationsArray)
    setLoading(false)
  }

  const updateMirrorDisplay = (selectedSeats, occupiedSeats, available, tripInfoOverride, seatDataOverride) => {
    const mirrorData = {
      seatData: seatDataOverride || forms, // Esto incluye los precios de los asientos (puede recibir override)
      selectedSeats: selectedSeats,
      occupiedSeats: occupiedSeats,
      available: available,
      timestamp: new Date().toISOString(),
      forceUpdate: Math.random()
    }

    // Guardar datos de asientos
    localStorage.setItem("mirrorSeatData", JSON.stringify(mirrorData))

    // Construir información del viaje: usar override si se proporciona (evita race con setState)
    let tripInfo = {}
    if (tripInfoOverride) {
      tripInfo = tripInfoOverride
    } else {
      // Intentar preservar la información existente en localStorage para evitar sobrescribir con datos antiguos
      try {
        const existing = localStorage.getItem("mirrorTripInfo")
        if (existing) {
          tripInfo = JSON.parse(existing)
        }
      } catch (err) {
        tripInfo = {}
      }

      // Rellenar campos faltantes con los estados actuales (si están disponibles)
      tripInfo.base = tripInfo.base || branchs.find(b => b.value == branch_id)?.label || ""
      tripInfo.origin = tripInfo.origin || origin || ""
      tripInfo.destination = tripInfo.destination || destination || ""
      tripInfo.date = tripInfo.date || dateSelect || ""
      tripInfo.time = tripInfo.time || timeSelect || ""
    }

    localStorage.setItem("mirrorTripInfo", JSON.stringify(tripInfo))

    // Disparar evento personalizado para notificar a la pantalla espejo
    // Notificamos solo mirrorSeatData porque SeatMirrorDisplay escucha ambos keys y leerá mirrorTripInfo al manejar el evento
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'mirrorSeatData',
      newValue: JSON.stringify(mirrorData)
    }));

    // También emitir un evento personalizado para garantizar actualización en la misma pestaña
    window.dispatchEvent(new Event('forceMirrorUpdate'));

    console.log("🔄 Datos actualizados para pantalla espejo:", mirrorData, "tripInfo:", tripInfo)
  }

  const handleChooseTrip = async (schedule_id, origin, destination, date, time, available, branch_id, origin_id, destination_id) => {
    // Reset selected seats and forms when choosing a new trip
    setSelectedSeats([])
    setForms({})
    setTotal(0)
    setPetTotal(0)
    setLuggageTotal(0)
    setTicketType("printed")

    // Guardar los valores ORIGINALES de la corrida seleccionada
    setScheduleId(schedule_id)
    setSelectedBranchId(branch_id) // <-- Guardar branch_id original
    setSelectedOriginId(origin_id) // <-- Guardar origin_id original
    setSelectedDestinationId(destination_id) // <-- Guardar destination_id original
    setOrigin(origin)
    setDestination(destination)
    setDateSelect(date)
    setTimeSelect(time)
    setAvailable(available)

    // Inicializar pantalla espejo con datos correctos DESPUÉS
    const baseLabel = branchs.find(b => b.value == branch_id)?.label || ""
    updateMirrorDisplay([], [], available, {
      base: baseLabel,
      origin: origin,
      destination: destination,
      date: date,
      time: time
    })

    // Then proceed with the existing functionality
    getAllBookingSeats(schedule_id, date, available, origin_id, destination_id)
  }

  const getAllBookingSeats = async (schedule_id, date, availableValue, origin_id, destination_id) => {
  setLoading(true)
  const form = new FormData()
  form.append("schedule_id", schedule_id)
  form.append("date", date)
  form.append("origin_id", origin_id)
  form.append("destination_id", destination_id)
  await axios
    .post(ENDPOINT + "get-all-booking-seats", form)
    .then((response) => {
      setLoading(false)
      // Asegúrate que la respuesta incluya name, status, invoice, etc.
      const seatData = response.data.data.map((seat) => ({
        seat: seat.seat,
        status: seat.status,
        name: seat.name || "N/A",
        last_name: seat.last_name || "",
        invoice: seat.invoice || "N/A",
        restriction_type: seat.restriction_type || null, // Nuevo campo
      }))
      
      // Separar asientos ocupados/reservados de los que tienen restricción
      const occupiedSeatNumbers = seatData
        .filter(seat => seat.status === 1 || seat.status === 2 || seat.status === 4)
        .map((seat) => seat.seat)
      
      const restrictedSeatNumbers = seatData
        .filter(seat => seat.status === 5) // Estado 5 = con restricción
        .map((seat) => seat.seat)
      
      setOccupiedSeats(occupiedSeatNumbers)
      setSeatData(seatData)
      // Actualizar pantalla espejo con asientos ocupados y el available correcto
      updateMirrorDisplay([], occupiedSeatNumbers, availableValue)
    })
    .catch((error) => {
      setLoading(false)
      console.log(error)
    })
}

  const handlePrint = async (purchase_order) => {
    setLoading(true)
    const form = new FormData()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    form.append("purchase_order", purchase_order)
    form.append("user_id", user_id)
    const response = await axios.post(ENDPOINT + "print-pdf-ticket", form, { responseType: "blob" })
    const url = window.URL.createObjectURL(response.data)
    window.open(url, "_blank")
    setLoading(false)
    resetAll()
    // Limpiar pantalla espejo
    try {
      updateMirrorDisplay([], [], 0, { base: "", origin: "", destination: "", date: "", time: "" })
    } catch (err) {
      console.warn("No se pudo actualizar mirror después de imprimir:", err)
    }
  }

  const handleSeatClick = (seatNumber) => {
  const seatInfo = seatData?.find((seat) => seat.seat === seatNumber)
  const isOccupied = seatInfo && (seatInfo.status === 1)
  const isReserved = seatInfo && seatInfo.status === 2
  const isPending = seatInfo && seatInfo.status === 4
  const isRestricted = seatInfo && seatInfo.status === 5 // Permitir seleccionar
  
  // No permitir seleccionar si está ocupado, reservado o pendiente
  if (isOccupied || isReserved || isPending) return
  
  setSelectedSeats((prev) => {
    let newSelected
    if (prev.includes(seatNumber)) {
      const newForms = { ...forms }
      delete newForms[seatNumber]
      setForms(newForms)
      newSelected = prev.filter((seat) => seat !== seatNumber)
    } else {
      const roundTripTemplate = outboundPassengerTemplates[prev.length] || outboundPassengerTemplates[0] || null
      const defaultPassenger = getDefaultPassengerForm()
      const nextPassenger = roundTripTemplate && tripStage === "return"
        ? {
            ...defaultPassenger,
            ...roundTripTemplate,
            seat: seatNumber,
            price: Number(roundTripTemplate.price || 0),
            name: roundTripTemplate.name || "",
            last_name: roundTripTemplate.last_name || "",
            email: roundTripTemplate.email || "",
            phone: roundTripTemplate.phone || "",
          }
        : {
            ...defaultPassenger,
            seat: seatNumber,
          }

      setForms((prevForms) => ({
        ...prevForms,
        [seatNumber]: nextPassenger,
      }))
      newSelected = [...prev, seatNumber]
    }
    updateMirrorDisplay(newSelected, occupiedSeats, available)
    return newSelected
  })
}

  const handleFormChange = (seatNumber, field, value) => {
    setForms((prev) => {
      const next = {
        ...prev,
        [seatNumber]: { ...prev[seatNumber], [field]: value },
      }
      try {
        // Actualizar mirror en tiempo real enviando el objeto actualizado
        updateMirrorDisplay(selectedSeats, occupiedSeats, available, null, next)
      } catch (err) {
        console.warn("Error actualizando mirror en handleFormChange:", err)
      }
      return next
    })
  }

  const calculateTotal = () => {
    let seatTotal = 0 // Changed from const to let
    const petSum = Number.parseFloat(forms.pet === 1 ? forms.petAmount : 0) // Changed from const to let
    const luggageSum = Number.parseFloat(forms.extraLuggage === 1 ? forms.extraLuggageAmount : 0) // Changed from const to let

    Object.values(forms).forEach((form) => {
      seatTotal += Number.parseFloat(form.price) || 0
    })

    setTotal(seatTotal + petSum + luggageSum)
    setPetTotal(petSum)
    setLuggageTotal(luggageSum)
  }

  const handleGeneralInfoChange = (val) => {
    setTransactionType(Number.parseInt(val))
  }

  const resetAll = () => {
    setSelectedSeats([])
    setForms({})
    setTotal(0)
    setPetTotal(0)
    setLuggageTotal(0)
    setTicketType("printed")
    setShowConfirmation(false)
    setConfirmationSummary([])
    setOutboundPassengerTemplates([])
    setSelectedBranchId(0)
    setSelectedOriginId(0)
    setSelectedDestinationId(0)
    setIsRoundTrip(false)
    setTripStage("outbound")
    setOutboundPurchaseOrder("")
    setOutboundTicketId("")
  }

  const cancelRoundTripConfirmation = async () => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user?.user_id || 0
    const targetId = outboundTicketId || outboundPurchaseOrder
    const cancelUrl = outboundTicketId
      ? "cancel-order/" + outboundTicketId
      : outboundPurchaseOrder
        ? "cancel-ticket/" + outboundPurchaseOrder
        : null

    if (!cancelUrl) {
      Swal.fire({
        icon: "warning",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">No se encontró el identificador para cancelar la compra de ida.</div>',
      })
      return
    }

    try {
      await axios.put(ENDPOINT + cancelUrl, {
        status: 3,
        cancel_note: "Cancelación desde compra por viaje redondo.",
        user_cancel: user_id,
      })

      Swal.fire({
        icon: "success",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: false,
        timer: 2000,
        html: '<div class="text-custom-alert">Compra de ida cancelada correctamente.</div>',
      })
    } catch (error) {
      console.warn("No se pudo cancelar el boleto de ida:", error)
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">No se pudo cancelar el boleto de ida.</div>',
      })
    } finally {
      setShowConfirmation(false)
      setConfirmationSummary([])
      resetAll()
      try {
        updateMirrorDisplay([], [], 0, { base: "", origin: "", destination: "", date: "", time: "" })
      } catch (err) {
        console.warn("No se pudo limpiar mirror después de cancelar:", err)
      }
      $("#closemodal").trigger("click")
    }
  }

  const renderSeat = (number) => {
  if (!number) return <div className="seat-space" />
  
  const seatInfo = seatData?.find((seat) => seat.seat === number)
  const isOccupied = seatInfo && (seatInfo.status === 1) // Solo comprado
  const isReserved = seatInfo && seatInfo.status === 2
  const isPending = seatInfo && seatInfo.status === 4
  const isRestricted = seatInfo && seatInfo.status === 5 // Nuevo: asiento con restricción
  const isSelected = selectedSeats.includes(number)
  
  let seatImage = SeatAvailable
  if (isSelected) {
    seatImage = SeatSelected
  } else if (isOccupied) {
    seatImage = SeatTaken
  } else if (isRestricted) {
    // Nuevo: usar imagen especial para asientos con restricción
    seatImage = SeatAvailable // Puedes crear una imagen especial SeatRestricted
  }
  
  let statusText = ""
  if (isReserved) {
    statusText = "Reservado 📝"
  } else if (isPending) {
    statusText = "Pendiente de pago ⏰"
  } else if (isOccupied) {
    statusText = "Comprado ✅"
  } else if (isRestricted) {
    statusText = "Disponible con restricción ⚠️"
  }
  
  const passengerName = seatInfo ? `${seatInfo.name} ${seatInfo.last_name || ''}`.trim() : "N/A"
  const invoiceNumber = seatInfo?.invoice || "N/A"
  
  return (
    <div 
      className="seat-container"
      data-bs-toggle={isOccupied || isReserved || isPending || isRestricted ? "tooltip" : ""}
      data-bs-html="true"
      data-bs-placement="top"
      title={
        isOccupied || isReserved || isPending || isRestricted 
          ? `            
              Pasajero: ${passengerName}
              Asiento: # ${number}
              Estado: ${statusText}
              Folio: ${invoiceNumber}
              ${isRestricted ? 'Nota: Este asiento está disponible solo para viajes con origen 23 o menos' : ''}            
          ` 
          : ""
      }
    >
      <button
        key={number}
        onClick={() => handleSeatClick(number)}
        disabled={isOccupied || isReserved || isPending} // Los asientos con restricción NO están disabled
        className={`seat ${isOccupied ? "occupied" : ""} ${isSelected ? "selected" : ""} ${isReserved ? "reserved" : ""} ${isPending ? "pending" : ""} ${isRestricted ? "restricted" : ""}`}
        style={{
          backgroundImage: `url(${seatImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          border: isReserved ? "2px solid orange" : 
                  isPending ? "2px solid blue" : 
                  isRestricted ? "2px solid #8B4513" : "", // Café/marrón para restricción
          position: "relative",
          cursor: isOccupied || isReserved || isPending ? "not-allowed" : "pointer",
          // Agregar overlay para asientos con restricción
          ...(isRestricted && !isSelected && {
            filter: "sepia(0.3) saturate(1.5)"
          })
        }}
      >
        {(isReserved || isPending || isRestricted) && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              background: isReserved ? "orange" : 
                         isPending ? "blue" : 
                         isRestricted ? "#8B4513" : "transparent", // Café/marrón para restricción
              color: "white",
              fontSize: "8px",
              padding: "1px 3px",
              borderRadius: "0 0 0 4px",
            }}
          >
            {isReserved ? "R" : isPending ? "P" : isRestricted ? "R" : ""}
          </div>
        )}
        {isOccupied ? (
          <span className="font-semibold"></span>
        ) : isSelected ? (
          <span className="font-semibold text-white">{number}</span>
        ) : (
          <span className="font-semibold">{number}</span>
        )}
      </button>
    </div>
  )
}

  const formatDate = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  const formatTime = (timeString) => {
    if (!timeString) return ""
    const [hours, minutes] = timeString.split(":")
    const date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0")
    const ampm = date.getHours() >= 12 ? "PM" : "AM"
    const hours12 = date.getHours() % 12 || 12
    const formattedHours12 = hours12.toString().padStart(2, "0")
    return `${formattedHours12}:${formattedMinutes} ${ampm}`
  }

  return (
    <>
      {loading && <Loader />}
      <div className="modal fade" id="modal-default" aria-labelledby="modal-default" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-header-modal">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h4 className="modal-title">
                  {isRoundTrip && tripStage === "return" ? "VUELTA | " : "IDA | "}
                  {origin} - {destination} | Fecha: {dateSelect} Hora: {timeSelect}
                </h4>
                
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form id="formulario" onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  {/* Bus Layout */}
                  <div className="col-md-4 mb-4">
                    <div className="card sticky-top" style={{ top: "1rem" }}>
                      <div className="card-body">
                        <div className="card bus-legend-card">
                          <div className="card-header text-center">
                            <small className="text-muted" style={{ fontSize: "13px" }}>
                              Seleccione sus asientos
                            </small>
                          </div>
                          <div className="card-body">
                            <div className="legend-container">
                              {legendItems.map((item, index) => (
                                <div key={index} className="legend-item">
                                  <div
                                    style={{
                                      backgroundImage: `url(${item.icon})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                    }}
                                    className={`seat-icon ${item.colorClass}`}
                                  ></div>
                                  <span className="legend-text" style={{ fontSize: "13px" }}>
                                    {item.status}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="bus-layout">
                          <div className="driver-seat mb-3">
                            <img
                              src={Volante || "/placeholder.svg"}
                              alt="volante"
                              style={{ width: "32px", height: "32px" }}
                            />
                          </div>
                          {available === 11 ? (
                            Object.values(busLayout11).map((row, index) => (
                              <div key={index} className="d-flex justify-content-center gap-2 mb-2">
                                <div className="d-flex gap-2">
                                  {row.slice(0, 2).map((seat, idx) => (
                                    <React.Fragment key={`left-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                                <div className="seat-space gap-2" /> {/* Aisle */}
                                <div className="d-flex gap-2">
                                  {row.slice(3).map((seat, idx) => (
                                    <React.Fragment key={`right-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                          ) : available === 18 ? (
                            Object.values(busLayout18).map((row, index) => (
                              <div key={index} className="d-flex justify-content-center gap-2 mb-2">
                                <div className="d-flex gap-2">
                                  {row.slice(0, 2).map((seat, idx) => (
                                    <React.Fragment key={`left-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                                <div className="seat-space gap-2" /> {/* Aisle */}
                                <div className="d-flex gap-2">
                                  {row.slice(3).map((seat, idx) => (
                                    <React.Fragment key={`right-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                          ) : available === 20 ? (
                            Object.values(busLayout20).map((row, index) => (
                              <div key={index} className="d-flex justify-content-center gap-2 mb-2">
                                <div className="d-flex gap-2">
                                  {row.slice(0, 2).map((seat, idx) => (
                                    <React.Fragment key={`left-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                                <div className="seat-space gap-2" /> {/* Aisle */}
                                <div className="d-flex gap-2">
                                  {row.slice(3).map((seat, idx) => (
                                    <React.Fragment key={`right-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                          ) : available === 12 ? (
                            Object.values(busLayout12).map((row, index) => (
                              <div key={index} className="d-flex justify-content-center gap-2 mb-2">
                                <div className="d-flex gap-2">
                                  {row.slice(0, 2).map((seat, idx) => (
                                    <React.Fragment key={`left-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                                <div className="seat-space gap-2" /> {/* Aisle */}
                                <div className="d-flex gap-2">
                                  {row.slice(3).map((seat, idx) => (
                                    <React.Fragment key={`right-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                          ) :
                          
                          
                          (
                            <p>No hay layout disponible</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Passenger Forms and General Info */}
                  <div className="col-md-8">
                    <div className="passenger-forms-container">
                      {showConfirmation && isRoundTrip && tripStage === "return" ? (
                        <div className="card mb-4 border-success shadow-sm">
                          <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title mb-0">Confirmación de compra</h5>
                            <span className="badge bg-light text-success">Paso 2</span>
                          </div>
                          <div className="card-body p-4">
                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div>
                                <h6 className="mb-1 text-muted">Resumen general</h6>
                                <h4 className="mb-0 fw-bold">Ida y vuelta</h4>
                              </div>
                              <div className="text-end">
                                <div className="small text-muted">Total final</div>
                                <div className="fw-bold fs-4">
                                  ${confirmationSummary.reduce((sum, leg) => sum + Number(leg.total || 0), 0)}MXN
                                </div>
                              </div>
                            </div>

                            <div className="row g-4">
                              {confirmationSummary.map((leg, legIndex) => (
                                <div key={`${leg.label}-${legIndex}`} className="col-12">
                                  <div className="border rounded p-3 bg-light-subtle">
                                    <h6 className="fw-bold mb-3 text-uppercase">{leg.label}</h6>
                                    <div className="mb-3 small text-muted">
                                      <div><strong>Fecha:</strong> {leg.date}</div>
                                      <div><strong>Horario:</strong> {leg.time}</div>
                                      <div><strong>Asientos:</strong> {leg.items.map((item) => item.seat).join(", ") || "—"}</div>
                                    </div>
                                    <div className="table-responsive">
                                      <table className="table table-sm mb-0 align-middle">
                                        <thead>
                                          <tr>
                                            <th>Asiento</th>
                                            <th>Pasajero</th>
                                            <th className="text-end">Precio</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {leg.items.map((item, itemIndex) => (
                                            <tr key={`${leg.label}-${item.seat}-${itemIndex}`}>
                                              <td>{item.seat}</td>
                                              <td>{item.passenger}</td>
                                              <td className="text-end">${item.price}MXN</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                            <td colSpan="2" className="fw-bold">Subtotal</td>
                                            <td className="text-end fw-bold">${leg.total}MXN</td>
                                          </tr>
                                        </tfoot>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <div className="d-flex justify-content-between align-items-center border-top pt-3 mt-4">
                              <span className="fw-bold">Monto total a pagar</span>
                              <span className="fw-bold fs-5 text-success">
                                ${confirmationSummary.reduce((sum, leg) => sum + Number(leg.total || 0), 0)}MXN
                              </span>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-4">
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={cancelRoundTripConfirmation}
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={executeTicketSave}
                              >
                                Confirmar compra
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="card mb-4">
                            <div className="card-header bg-header-modal">
                              <h5 className="card-title page-title mb-0 text-white">Resumen de la venta</h5>
                            </div>
                            <div className="card-body">
                              <table className="table table-responsive">
                                <thead>
                                  <tr>
                                    <th>Concepto</th>
                                    <th className="text-end">Monto</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Asientos</td>
                                    <td className="text-end">${total - petTotal - luggageTotal}MXN</td>
                                  </tr>
                                  <tr>
                                    <td>Mascotas</td>
                                    <td className="text-end">${petTotal}MXN</td>
                                  </tr>
                                  <tr>
                                    <td>Equipaje extra</td>
                                    <td className="text-end">${luggageTotal}MXN</td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr className="fw-bold">
                                    <td>Total</td>
                                    <td className="text-end">${total}MXN</td>
                                  </tr>
                                </tfoot>
                              </table>
                              <div className="row g-3 align-items-center mt-3">
                                <div className="col-12 col-md-6">
                                  <div className="d-flex flex-column flex-md-row align-items-md-center">
                                    <label htmlFor="transactionType" className="form-label me-md-2 mb-2 mb-md-0">
                                      Tipo de transacción:
                                    </label>
                                    <select
                                      required
                                      id="transactionType"
                                      className="form-select form-control form-control-sm"
                                      value={transactionType}
                                      onChange={(e) => handleGeneralInfoChange(e.target.value)}
                                    >
                                      <option value="">Seleccione</option>
                                      {status_trip.map((item, index) => (
                                        <option key={index} value={item.value}>
                                          {item.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6">
                                  <div className="d-flex flex-column flex-md-row gap-2 justify-content-md-end">
                                    <button
                                      type="button"
                                      id="closemodal"
                                      onClick={resetAll}
                                      data-bs-dismiss="modal"
                                      className="btn btn-danger w-100 w-md-auto"
                                    >
                                      <i className="fa fa-times me-2"></i>
                                      Cancelar
                                    </button>
                                    <button className="btn btn-success w-100 w-md-auto">
                                      <i className="fa fa-check me-2"></i>
                                      Procesar
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="d-flex align-items-center justify-content-center bg-light p-3 rounded">
                                    <div className="form-check form-switch form-switch-lg me-3">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="ticketTypeSwitch"
                                        style={{ width: "3rem", height: "1.5rem" }}
                                        checked={ticketType === "whatsapp"}
                                        onChange={(e) => setTicketType(e.target.checked ? "whatsapp" : "printed")}
                                      />
                                    </div>
                                    <label 
                                      className="form-check-label fw-bold fs-5" 
                                      htmlFor="ticketTypeSwitch"
                                      style={{ color: ticketType === "whatsapp" ? "#25D366" : "#0d6efd" }}
                                    >
                                      {ticketType === "whatsapp" ? (
                                        <><i className="fab fa-whatsapp me-2"></i> Boleto digital por WhatsApp</>
                                      ) : (
                                        <><i className="fas fa-print me-2"></i> Boleto Impreso</>
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {JSON.parse(localStorage.getItem("dataUser"))?.user_id === 13 && (
                                <div className="row mt-3">
                                  <div className="col-12">
                                    <label htmlFor="userSelect" className="form-label">
                                      Seleccionar Usuario:
                                    </label>
                                    <select
                                      id="userSelect"
                                      className="form-select form-control-sm"
                                      value={selectedUserId}
                                      onChange={(e) => setSelectedUserId(Number.parseInt(e.target.value))}        
                                    >
                                      <option value="">Seleccione un usuario</option>
                                      {users.map((user) => (
                                        <option key={user.user_id} value={user.user_id}>
                                          {user.name} {user.last_name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {selectedSeats.map((seatNumber) => (
                            <div key={seatNumber} className="card mb-4">
                              <div className="card-header bg-header-modal d-flex justify-content-between align-items-center py-2">
                                <div className="d-flex align-items-center">
                                  <i className="fas fa-user-circle me-2" style={{ fontSize: "1rem" }}></i>
                                  <h6 className="card-title mb-0">Pasajero - Asiento {seatNumber}</h6>
                                </div>
                                <button
                                  onClick={() => handleSeatClick(seatNumber)}
                                  className="btn btn-link p-0"
                                  style={{ color: "white" }}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                              <div className="card-body">
                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Nombres"
                                      value={forms[seatNumber]?.name || ""}
                                      onChange={(e) => handleFormChange(seatNumber, "name", e.target.value)}
                                      required
                                      readOnly={tripStage === "return" && isRoundTrip}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Apellidos (Opcional)"
                                      value={forms[seatNumber]?.last_name || ""}
                                      onChange={(e) => handleFormChange(seatNumber, "last_name", e.target.value)}
                                      readOnly={tripStage === "return" && isRoundTrip}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="email"
                                      className="form-control form-control-sm"
                                      placeholder="Email (Opcional)"
                                      value={forms[seatNumber]?.email || ""}
                                      onChange={(e) => handleFormChange(seatNumber, "email", e.target.value)}
                                      readOnly={tripStage === "return" && isRoundTrip}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <input
                                      type="tel"
                                      className="form-control form-control-sm"
                                      placeholder="Teléfono (Opcional)"
                                      value={forms[seatNumber]?.phone || ""}
                                      onChange={(e) => handleFormChange(seatNumber, "phone", e.target.value)}
                                      readOnly={tripStage === "return" && isRoundTrip}
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Precio"
                                      value={forms[seatNumber]?.price || ""}
                                      onChange={(e) => handleFormChange(seatNumber, "price", e.target.value)}
                                      required
                                    />
                                  </div>
                                  <div className="form-section">
                                    <div className="row g-2">
                                      <div className="col-12">
                                        <label className="form-label">¿Dónde suben?</label>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={forms[seatNumber]?.pickupLocation || ""}
                                          onChange={(e) => handleFormChange(seatNumber, "pickupLocation", e.target.value)}
                                          placeholder="Ej. Terminal principal"
                                        />
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">Anotaciones</label>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          value={forms[seatNumber]?.notes || ""}
                                          onChange={(e) => handleFormChange(seatNumber, "notes", e.target.value)}
                                          placeholder="Ej. Pasajero con necesidades especiales"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="form-section">
                                    <div className="row g-2">
                                      <div className="col-md-3 d-none">
                                        <label className="form-label d-block">Cortesía</label>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name={`courtesy_${seatNumber}`}
                                            value="1"
                                            checked={forms[seatNumber]?.courtesy === 1}
                                            onChange={() => handleFormChange(seatNumber, "courtesy", 1)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">Sí</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name={`courtesy_${seatNumber}`}
                                            value="2"
                                            checked={forms[seatNumber]?.courtesy === 2}
                                            onChange={() => handleFormChange(seatNumber, "courtesy", 2)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">No</label>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <label className="form-label d-block">Exceso de equipaje</label>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`extraLuggage_${seatNumber}`}
                                            checked={forms[seatNumber]?.extraLuggage === 1}
                                            onChange={() => handleFormChange(seatNumber, "extraLuggage", 1)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">Sí</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`extraLuggage_${seatNumber}`}
                                            checked={forms[seatNumber]?.extraLuggage === 2}
                                            onChange={() => handleFormChange(seatNumber, "extraLuggage", 2)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">No</label>
                                        </div>
                                        {forms[seatNumber]?.extraLuggage === 1 && (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm mt-2"
                                            value={forms[seatNumber]?.extraLuggageAmount || ""}
                                            onChange={(e) =>
                                              handleFormChange(seatNumber, "extraLuggageAmount", e.target.value)
                                            }
                                            placeholder="Monto"
                                            required
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                        )}
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label d-block">Mascota</label>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`pet_${seatNumber}`}
                                            checked={forms[seatNumber]?.pet === 1}
                                            onChange={() => handleFormChange(seatNumber, "pet", 1)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">Sí</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`pet_${seatNumber}`}
                                            checked={forms[seatNumber]?.pet === 2}
                                            onChange={() => handleFormChange(seatNumber, "pet", 2)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">No</label>
                                        </div>
                                        {forms[seatNumber]?.pet === 1 && (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm mt-2"
                                            value={forms[seatNumber]?.petAmount || ""}
                                            onChange={(e) => handleFormChange(seatNumber, "petAmount", e.target.value)}
                                            placeholder="Monto"
                                            required
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                        )}
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label d-block">Pago con tarjeta</label>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`cardPayment_${seatNumber}`}
                                            checked={forms[seatNumber]?.cardPayment === 1}
                                            onChange={() => handleFormChange(seatNumber, "cardPayment", 1)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">Sí</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`cardPayment_${seatNumber}`}
                                            checked={forms[seatNumber]?.cardPayment === 2}
                                            onChange={() => handleFormChange(seatNumber, "cardPayment", 2)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">No</label>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label d-block">Pago con transferencia</label>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`cardPaymentTransfer_${seatNumber}`}
                                            checked={forms[seatNumber]?.cardPaymentTransfer === 1}
                                            onChange={() => handleFormChange(seatNumber, "cardPaymentTransfer", 1)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">Sí</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            name={`cardPaymentTransfer_${seatNumber}`}
                                            checked={forms[seatNumber]?.cardPaymentTransfer === 2}
                                            onChange={() => handleFormChange(seatNumber, "cardPaymentTransfer", 2)}
                                            disabled={tripStage === "return" && isRoundTrip}
                                          />
                                          <label className="form-check-label">No</label>
                                        </div>
                                        {forms[seatNumber]?.cardPaymentTransfer === 1 && (
                                          <input
                                            type="text"
                                            className="form-control form-control-sm mt-3"
                                            value={forms[seatNumber]?.transferNumber || ""}
                                            onChange={(e) => handleFormChange(seatNumber, "transferNumber", e.target.value)}
                                            placeholder="Banco / Ultimos Num Ref"
                                            required
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <ContentHeader title="Módulo de Boletos" />
      </div>

      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="indications-header row">
              <div className="col-md-7">
                <h4 className="card-title m-0 page-title">
                  <i className="bi bi-clipboard-plus me-2"></i>Generar Boleto
                </h4>
              </div>
              <div className="col-md-5" style={{ textAlign: "right" }}>
                <Link to="/listado-boletos" className="btn btn-secondary btn-sm me-1">
                  <i className="fa-solid fa-list-check me-1"></i> Listado de boletos
                </Link>
                <button onClick={() => window.location.reload()} className="btn btn-info btn-sm me-1" type="button">
                  <i className="fa fa-refresh me-1"></i> Recargar
                </button>
                <button 
                  type="button" 
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    // Forzar actualización antes de abrir
                    updateMirrorDisplay(selectedSeats, occupiedSeats, available);
                    
                    // Abrir la ventana
                    const mirrorWindow = window.open(
                      '/admin/seat-mirror-display', 
                      'admin/mirrorDisplay', 
                      'width=1024,height=768,resizable=yes'
                    );
                    
                    // Enfocar la ventana si ya existe
                    if (mirrorWindow) {
                      mirrorWindow.focus();
                    }
                  }}
                  title="Abrir pantalla espejo"
                >
                  <i className="fas fa-tv me-1"></i>Pantalla Asientos
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12">
                <div className="d-flex gap-2 flex-wrap">
                  {/* Original quick-search buttons (llenan la tabla) */}
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => handleQuickSearch(1, 1, 25)}
                  >
                    <i className="fa fa-bolt me-1"></i> Oaxaca - Salina Cruz
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                    onClick={() => handleQuickSearch(2, 25, 1)}
                  >
                    <i className="fa fa-bolt me-1"></i> Salina Cruz - Oaxaca
                  </button>

                  {/* New quick-nearest buttons (seleccionan la corrida próxima y abren el modal) */}
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => handleQuickNearest(1, 1, 25)}
                  >
                    <i className="fa fa-location-crosshairs me-1"></i> Corrida más próxima Oaxaca - Salina Cruz
                  </button>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={() => handleQuickNearest(2, 25, 1)}
                  >
                    <i className="fa fa-location-crosshairs me-1"></i> Corrida más próxima Salina Cruz - Oaxaca
                  </button>
                </div>
                <small className="text-muted mt-1 d-block">
                  <i className="fa fa-lightbulb me-1"></i> Accesos rápidos para búsquedas frecuentes
                </small>
              </div>
            </div>

            <div className="add-ticket-form-header">
              <h6 className="add-ticket-form-title">
                <i className="bi bi-funnel me-2"></i>Parametros de Busqueda de Horarios
              </h6>
              <p
                className="add-ticket-form-subtitle"
                style={{ borderBottom: "1px solid #dee2e6", paddingBottom: "0.5rem" }}
              >
                Use los siguientes filtros para buscar viajes disponibles
              </p>
            </div>
            <form onSubmit={handleSearch}>
              <div className="add-ticket-indications row mb-4">
                <div className="form-group col-md-2 col-sm-6 mb-2">
                  <label htmlFor="branch_id" className="col-form-label col-form-label-sm">
                    Base <span className="add-ticket-required">*</span>
                  </label>
                  <select className="form-control form-control-sm select2" id="branch_id" name="branch_id" required>
                    <option selected value="">
                      Seleccione base
                    </option>
                    {branchs.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  <small className="add-ticket-field-hint">Seleccione la base de operación</small>
                </div>
                <div className="form-group col-md-2 col-sm-6 mb-2">
                  <label htmlFor="origin_id" className="col-form-label col-form-label-sm">
                    Origen <span className="add-ticket-required">*</span>
                  </label>
                  <select className="form-control form-control-sm select2" id="origin_id" name="origin_id" required>
                    <option selected value="">
                      Seleccione origen
                    </option>
                    {origins.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  <small className="add-ticket-field-hint">Seleccione el origen del viaje</small>
                </div>
                <div className="form-group col-md-2 col-sm-6 mb-2">
                  <label htmlFor="destination_id" className="col-form-label col-form-label-sm">
                    Destino <span className="add-ticket-required">*</span>
                  </label>
                  <select
                    className="form-control form-control-sm select2"
                    id="destination_id"
                    name="destination_id"
                    required
                  >
                    <option selected value="">
                      Seleccione destino
                    </option>
                    {destinations.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  <small className="add-ticket-field-hint">Seleccione el destino del viaje</small>
                </div>
                <div className="form-group col-md-2 col-sm-6 mb-2">
                  <label htmlFor="date" className="col-form-label col-form-label-sm">
                    Fecha <span className="add-ticket-required">*</span>
                  </label>
                  <DatePicker
                    showIcon
                    locale="es"
                    selected={date}
                    onChange={(date) => setDate(date)}
                    minDate={new Date()}
                    //maxDate={date_max}
                    className="form-control form-control-sm"
                    dateFormat="dd, MMMM, yyyy"
                  />
                  <small className="add-ticket-field-hint">Seleccione la fecha del viaje</small>
                </div>
                <div className="form-group col-md-2 col-sm-6 mb-2">
                  <div className={`round-trip-switch ${isRoundTrip ? "is-active" : ""}`}>
                    <div className="round-trip-switch-copy">
                      <span className="round-trip-switch-title">Boleto redondo</span>
                      <span className="round-trip-switch-subtitle">
                        {isRoundTrip ? "Ida y vuelta" : "Solo ida"}
                      </span>
                    </div>
                    <label className="switch-control" htmlFor="roundTrip">
                      <input
                        id="roundTrip"
                        type="checkbox"
                        checked={isRoundTrip}
                        onChange={(event) => {
                          setIsRoundTrip(event.target.checked)
                          setTripStage("outbound")
                        }}
                      />
                      <span className="switch-slider" aria-hidden="true" />
                    </label>
                  </div>
                </div>
                {isRoundTrip && (
                  <div className="form-group col-md-2 col-sm-6 mb-2 round-trip-date-field">
                    <label htmlFor="returnDate" className="col-form-label col-form-label-sm">
                      Fecha de vuelta
                    </label>
                    <DatePicker
                      showIcon
                      locale="es"
                      selected={returnDate}
                      onChange={(selectedDate) => setReturnDate(selectedDate)}
                      minDate={date}
                      className="form-control form-control-sm"
                      dateFormat="dd, MMMM, yyyy"
                      disabled={tripStage === "return"}
                    />
                    <small className="add-ticket-field-hint">Después de la ida</small>
                  </div>
                )}
                <div className="col-md-2 col-sm-6 mb-4 d-flex align-items-end">
                  <div className="add-ticket-filter-actions">
                    <button id="search" type="submit" className="btn btn-primary w-100">
                      <i className="fa-solid fa-magnifying-glass me-1"></i> Buscar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <table className="table table-hover main table-striped">
              <thead>
                <tr>
                  <th width="20%" className="text-left">
                    Base
                  </th>
                  <th width="20%" className="text-left">
                    Origen
                  </th>
                  <th width="20%" className="text-left">
                    Destino
                  </th>
                  <th width="10%" className="text-center">
                    Horario
                  </th>
                  <th width="10%" className="text-center">
                    Fecha
                  </th>
                  <th width="15%" className="text-center">
                    Asntos Disp
                  </th>
                  <th width="10%" className="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {search.map((item, index) => (
                  <tr key={index}>
                    <td>{item.base}</td>
                    <td>{item.origin}</td>
                    <td>{item.destination}</td>
                    <td className="text-center">{formatTime(item.time)}</td>
                    <td className="text-center">{formatDate(item.date)}</td>
                    <td className="text-center">{item.seats}</td>
                    <td className="text-center">
                      <div>
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#modal-default"
                          onClick={() =>
                            handleChooseTrip(
                              item.schedule_id,
                              item.origin,
                              item.destination,
                              item.date,
                              item.time,
                              item.available,
                              item.branch_id,
                              item.origin_id,
                              item.destination_id
                            )
                          }
                          className="btn btn-success btn-sm"
                        >
                          <i className="fa-solid fa-arrow-right me-1"></i>Elegir
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default Tickets